import Component from '../classes/component';

enum FeedbackType {
  error,
  success,
}

const feedbackTypes = Object.keys(FeedbackType);

const SELECTORS = {
  input: 'input',
  button: '.icon-button',
};

class PromoCode extends Component<typeof SELECTORS> {
  protected _selectors = SELECTORS;

  private _handleFocusIn() {
    this.container.classList.add('focused');
  }

  private _handleFocusOut() {
    this.container.classList.remove('focused');
  }

  private _handleSubmit() {
    this._getChild('button').classList.remove(...feedbackTypes);
    this._getChild('button').classList.add('is-loading');
    setTimeout(() => {
      this._getChild('button').classList.remove('is-loading');
      this._getChild('button').classList.add('success');
    }, 1000);
  }

  protected _onEnter() {
    this._addListener('input', 'focusin', this._handleFocusIn);
    this._addListener('input', 'focusout', this._handleFocusOut);
    this._addListener('button', 'mousedown', this._handleSubmit);
  }
}

export default PromoCode;
